// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080649/js/" + chunkId + "." + {"44":"80acd18d","225":"3c8a5a86","481":"3cd051de","486":"088885c8","770":"9974b347"}[chunkId] + ".0.5868066045396532.chunk.js";
};